module.exports = _.isNumber;


//////////////////
// WEBPACK FOOTER
// external "_.isNumber"
// module id = 1263
// module chunks = full-screen-modals/full-screen-modals mobile-overlay/mobile-overlay mobile/mobile widget/widget